export enum QueueVolumeIndicator {
  BelowMin,
  Normal,
  AboveMax,
  Empty,
}
